// IMPORTANT: Build gql after ANY changes to queries (client OR api)

import { graphql } from '@/client/services/api/graphql/gql';

export const markAssignmentCompletedMutation: any = graphql(`
  mutation MarkAssignmentCompleted($completeAssignmentInput: AssignmentActionInput!) {
    completeAssignments(completeInput: $completeAssignmentInput)
  }
`);

export const archiveAssignmentMutation: any = graphql(`
  mutation ArchiveAssignments($archiveAssignmentInput: AssignmentActionInput!) {
    archiveAssignments(archiveInput: $archiveAssignmentInput)
  }
`);

export const sendAssignmentReminderMutation: any = graphql(`
  mutation SendAssignmentReminder($assignmentReminderInput: AssignmentActionInput!) {
    sendAssignmentReminder(reminderInput: $assignmentReminderInput)
  }
`);
